import { z } from 'zod';

const BridgeCrossingTypeDef = ['Wood', 'Steel', 'Gravel', 'Culvert'] as const;

export const allBridgeCrossingTypes = [...BridgeCrossingTypeDef];

export type BridgeCrossingType = (typeof BridgeCrossingTypeDef)[number];

export const bridgeCrossingTypeSchema = z.enum(BridgeCrossingTypeDef);
